import KendoContextMenuMixin from './KendoContextMenuMixin'

export default {
    name: 'kendo-contextmenu',
    mixins: [ KendoContextMenuMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoContextMenu/index.js